export default {
  sinisterCode: {
    value: '',
    maxlength: '20',
    required: false,
    state: null
  },
  sinisterVersion: {
    value: '',
    maxlength: '2',
    required: false,
    state: null
  },
  insurance: {
    value: '',
    maxlength: '100',
    required: false,
    state: null
  },
  insured: {
    value: '',
    maxlength: '100',
    required: false,
    state: null
  }
}



// WEBPACK FOOTER //
// ./src/components/regulation/auto/sinisterheader/form/sinisterheader-form.js